import { createBaseFormatterFactory } from './baseUtils.js';
/**
 * Format a number as hexadecimal.
 *
 * Syntax:
 *
 *    math.hex(value)
 *
 * Examples:
 *
 *    //the following outputs "0xF0"
 *    math.hex(240)
 *
 * See also:
 *
 *    oct
 *    bin
 *
 * @param {number} value    Value to be stringified
 * @return {string}         The formatted value
 */

export var createHex = createBaseFormatterFactory('hex', 16);


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/function/string/hex.js
// module id = null
// module chunks = 